import {createContext, FC} from 'react'
import {WithChildren} from '../../../../../../template/_metronic/helpers'

type WizardContextType = {
  submitStep: () => void
  nextStep: () => void
  prevStep: () => void
}

export const WizardContext = createContext<WizardContextType>({
  submitStep: () => {},
  nextStep: () => {},
  prevStep: () => {},
})

export const WizardProvider: FC<WizardContextType & WithChildren> = ({
  submitStep,
  nextStep,
  prevStep,
  children,
}) => {
  return (
    <WizardContext.Provider value={{submitStep, nextStep, prevStep}}>
      {children}
    </WizardContext.Provider>
  )
}
